import React from 'react';

import styled, { withTheme, keyframes } from 'styled-components';

const SpinnerContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Full screen height */
    width: 100vw; /* Full screen width */
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.2);
    z-index: 9999; /* Ensure it's on top of other content */
`;

// Define the keyframes animation
const FadInOut = keyframes`
  0%, 80%, 100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
`;

// Create the styled-component
const LoaderWrapper = styled.span`
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: ${FadInOut} 1.8s infinite ease-in-out;
    color: ${props => props.theme.palette.primary.main};
    font-size: 7px;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;

    &::before,
    &::after {
        content: '';
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
        position: absolute;
        top: 0;
        animation-fill-mode: both;
        animation: ${FadInOut} 1.8s infinite ease-in-out;
    }

    &::before {
        left: -3.5em;
        animation-delay: -0.32s;
    }

    &::after {
        left: 3.5em;
    }
`;

function Loading() {
    return (
        <SpinnerContainer data-testid="m7sqvznn-x5c6zp">
            <LoaderWrapper data-testid="m7sqvznn-bdgtjl" />
        </SpinnerContainer>
    );
}

export default withTheme(Loading);
